<template>
  <div class="identify-device">
    <div class="close" @click="closeWindow">
      <img class="closeimg" src='../../assets/images/new-login-2018/close@2x.png' alt=''>
    </div>

    <div class="title">{{ indentifyTitile }}</div>

    <div class="description">{{ description }}</div>

    <div class="showDeviceInfo" @click='openList' :style="showAccountList ? 'borderColor: #58a6e7 ': ''">
      <div class="useDevice">{{ useDeviceTip }}</div>
      <div class="useDevice deviceAccount">{{ currentAccount }}</div>
      <div class="dropbutton" v-show='showdropbutton'>
        <img class='dropimg' src='../../assets/images/new-login-2018/dropbutton.png' alt=''>
      </div>
    </div>

    <div class='devicelist' v-show='showAccountList'>
      <div class='deviceitem' v-for="(value, key) in accountList" @click='selectAccount(value, key)'>
        <div class="useDevice">{{ getDeviceName(key) }}</div>
        <div class="useDevice deviceAccount">{{ getDeviceValue(key) }}</div>
      </div>
    </div>

    <div class="getVerifyCode">
      <input type="text" class="inputcode" placeholder="input your code"/>
      <div class="timer" v-show='!showGetCode'> {{ showTimerTip }}</div>
      <div class="getcodebutton" v-show='showGetCode' @click="getCode">{{getCodeButtonTip}}</div>
      <div class="regetcodeTip" v-show='!showGetCode'>{{regetCodeTip}}</div>
    </div>

    <div class="needhelp" @click="openHelpWindow" v-show="!isGenericVersion">
      <img src='../../assets/images/new-login-2018/shape@2x.png' alt=''>
      <div class="helptip">{{ needHelpTip }}</div>
    </div>

    <div class="verifybutton" @click="sendVerifyCode" v-loading="verifyLoading" >{{ verifyButton }}</div>
  </div>
</template>

<script>
import translate from '../common/Translate.js'
import { MaxTimeOut, accountType } from '../common/Common.js'
import { post } from '../common/Axios.js'
import { Message } from 'element-ui'
import AppInfo from '../../appInfo/index'
export default {
  data () {
    return {
      indentifyTitile: translate('indentifyTitile'), // translate('indentifyTitile')
      description: translate('indentifyDescription'),
      useDeviceTip: translate('usePhoneTip'),
      inputCodeTip: translate('inputCodeTip'),
      timerTip: '00:',
      timerDecTip: translate('timerDecTip'),
      getCodeButtonTip: translate('getCodeButtonTip'),
      regetCodeTip: translate('regetCode'),
      needHelpTip: translate('needHelpTip'),
      verifyButton: translate('verifyButton'),
      currentKey: '',
      currentAccount: '',
      showGetCode: true,
      showAccountList: false,
      phoneTimerNum: MaxTimeOut,
      emailTimerNum: MaxTimeOut,
      phoneIntervalId: '',
      emailIntervalId: '',
      accountList: {},
      phoneCountryCode: '',
      userCode: '',
      verifyLoading: false,
      isGenericVersion: AppInfo.isGenericVersion()
      // {
      //   'country_code': '+86',
      //   'phone': '12345678901',
      //   'email': 'chenjiancao@myhexin.com'
      // }
    }
  },
  computed: {
    showdropbutton () {
      return Object.keys(this.accountList).length > 1
    },
    showTimerTip () {
      let showTimerNum
      if (this.currentKey === 'phone') {
        showTimerNum = this.getShowTimerNum(this.phoneTimerNum)
        return '00:' + showTimerNum + this.timerDecTip
      } else if (this.currentKey === 'email') {
        showTimerNum = this.getShowTimerNum(this.emailTimerNum)
        return '00:' + showTimerNum + this.timerDecTip
      }
    }
  },
  mounted () {
    if (this.$route.query) {
      // init country code.
      if (this.$route.query.country_code) {
        this.phoneCountryCode = this.$route.query.country_code
      }
      // init phone
      if (this.$route.query.phone) {
        this.accountList['phone'] = this.$route.query.phone
      }
      // init email.
      if (this.$route.query.email) {
        this.accountList['email'] = this.$route.query.email
      }
      // init code.
      if (this.$route.query.code) {
        this.userCode = this.$route.query.code
      }
    }
    // default use phone account.
    if (this.accountList.phone) {
      this.useDeviceTip = translate('usePhoneTip')
      this.currentAccount = this.phoneCountryCode + ' ' + this.accountList.phone
      this.currentKey = 'phone'
    } else {
      this.useDeviceTip = translate('useEmailTip')
      this.currentAccount = this.accountList.email
      this.currentKey = 'email'
    }
  },
  methods: {
    getShowTimerNum (time) {
      return time < 10 ? '0' + time : time
    },
    closeWindow () {
      console.log('close indetify window. ')
      this.$router.push('/login/signin')
    },
    getDeviceName (key) {
      if (key === 'phone') {
        return translate('usePhoneTip')
      } else if (key === 'email') {
        return translate('useEmailTip')
      }
    },
    getDeviceValue (key) {
      if (key === 'phone') {
        return this.phoneCountryCode + this.accountList.phone
      } else if (key === 'email') {
        return this.accountList.email
      }
    },
    async sendVerifyCode () {
      this.verifyLoading = true
      console.log('send verify code')
      let verifyCode = document.getElementsByClassName('inputcode')[0].value.trim()
      verifyCode = verifyCode.replace(/\s+/g, '')
      console.log(verifyCode)
      let requestParams = {
        code: this.userCode,
        capture: verifyCode,
        type: this.currentKey === 'phone' ? accountType.PHONE_TYPE : accountType.EMAIL_TYPE
      }
      // validate verify code.
      let res = await post('/proxy-api/client/user/index/validate-capture-by-code', requestParams).catch((err) => {
        return err
      })

      this.verifyLoading = false
      // verify success. perform login operation.
      if (+res.data.status === 0) {
        Message({
          message: 'Successful verification',
          type: 'success'
        })
        location.href = '../web/index.html'
      } else {
        Message({
          message: res.data.msg,
          type: 'error'
        })
      }
    },
    openList () {
      if (Object.keys(this.accountList).length > 1) {
        this.showAccountList = !this.showAccountList
      }
    },
    openHelpWindow () {
      let text = translate('helpTip')
      this.$confirm(text, '', {
        confirmButtonText: translate('sure'),
        type: 'info',
        showClose: false,
        showCancelButton: false
      }).then(() => {
        console.log('support@crait.com can help you.')
      }).catch(() => {
        console.log('support@crait.com can help you.')
      })
    },
    selectAccount (value, key) {
      this.useDeviceTip = this.getDeviceName(key)
      this.currentAccount = this.getDeviceValue(key)
      this.currentKey = key
      this.showAccountList = false
      if (key === 'phone' && this.phoneTimerNum === MaxTimeOut) {
        this.showGetCode = true
      } else if (key === 'email' && this.emailTimerNum === MaxTimeOut) {
        this.showGetCode = true
      } else {
        this.showGetCode = false
      }
    },
    async getCode () {
      let that = this
      this.showGetCode = false
      // set account to get verification code time.
      if (that.currentKey === 'phone') {
        this.phoneIntervalId = setInterval(() => {
          that.phoneTimerNum = that.phoneTimerNum - 1
          if (that.phoneTimerNum === 0) {
            window.clearInterval(that.phoneIntervalId)
            that.phoneTimerNum = MaxTimeOut
            if (this.currentKey === 'phone') {
              this.showGetCode = true
            }
          }
        }, 1000)
      } else if (that.currentKey === 'email') {
        this.emailIntervalId = setInterval(() => {
          that.emailTimerNum = that.emailTimerNum - 1
          if (that.emailTimerNum === 0) {
            window.clearInterval(that.emailIntervalId)
            that.emailTimerNum = MaxTimeOut
            if (this.currentKey === 'email') {
              this.showGetCode = true
            }
          }
        }, 1000)
      }

      // request send capture code.
      let requestParams = {
        code: this.userCode,
        device: 'web',
        type: that.currentKey === 'phone' ? accountType.PHONE_TYPE : accountType.EMAIL_TYPE
      }
      let res = await post('/proxy-api/client/user/index/send-capture-by-code', requestParams)
      console.log('send Capture code. res is', res)
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../assets/css/_mixin.less';
  .identify-device {
    .white-bg();
    min-height: 460px;
    margin-top: -230px;
    // 禁止文字被鼠标选中
    -moz-user-select: none;
    -o-user-select:none;
    -khtml-user-select:none;
    -webkit-user-select:none;
    -ms-user-select:none;
    user-select:none;

    .close {
      height: 73px;
      cursor: pointer;
      .closeimg {
        width: 14.8px;
        height: 14.8px;
        float: right;
        margin-top: 20.9px;
        margin-right: 20.3px;
      }
    }
    .title {
      font-size: 24px;
      color: #3E3E3E;
      text-align: center;
      line-height: 24px;
    }
    .description {
      margin-top: 16px;
      margin-left: 70px;
      width: 300px;
      font-size: 14px;
      color: #666666;
      text-align: center;
      line-height: 21px;
    }
    .showDeviceInfo {
      margin-top: 32px;
      margin-left: 70px;
      border: 1px solid #EEEEEE;
      border-radius: 2px;
      width: 300px;
      height: 40px;
      display: flex;
      align-items: center;
      cursor: pointer;
      .dropbutton {
        // margin-top: -6px;
        width: 28px;
        padding-left: 14px;
        cursor: pointer;
        .dropimg {
          width: 9px;
          height: 7px;
          line-height: 40px;
        }
      }
    }
    .useDevice {
      margin-left: 10px;
      width: 62px;
      font-size: 14px;
      color: #3E3E3E;;
      line-height: 12px;
    }
    .deviceAccount {
      margin-left: 6px;
      width: 187px;
    }
    .getVerifyCode {
      background: #F5F7FA;
      border: 1px solid #EEEEEE;
      border-radius: 2px;
      width: 300px;
      height: 40px;
      margin-top: 24px;
      margin-left: 70px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .inputcode {
        width: 121px;
        height: 40px;
        margin-left: 10px;
        font-size: 14px;
        color: #B8C1CC;
        line-height: 14px;
        border: none;
        background: #F5F7FA;
        outline: none;
        -webkit-tap-highlight-color: rgba(0,0,0,0);
        color: black;
      }
      .timer {
        margin-left: 40px;
        font-size: 12px;
      }
      .getcodebutton {
        margin-left: 3px;
        margin-right: 10px;
        font-size: 12px;
        cursor: pointer;
        color: #3F86DE;
      }
      .regetcodeTip {
        margin-left: 3px;
        margin-right: 10px;
        font-size: 12px;
        color: #000000;
      }
    }
    .needhelp {
      display: flex;
      margin-left: 70px;
      margin-top: 24px;
      font-size: 14px;
      color: #666666;
      line-height: 14px;
      cursor: pointer;
      .helptip {
        margin-left: 4px;
      }
    }
    .verifybutton {
      width: 300px;
      height: 40px;
      margin-top: 32px;
      margin-left: 70px;
      background: #3F86DE;
      border-radius: 2px;
      font-size: 14px;
      color: #FFFFFF;
      text-align: center;
      line-height: 40px;
      cursor: pointer;
    }
    .devicelist {
      position: absolute;
      margin-left: 70px;
      background: #FFFFFF;
      border: 1px solid #58a6e7;
      border-radius: 2px;
      width: 300px;
    }
    .deviceitem {
      height: 30px;
      display: flex;
      align-items: center;
      border-radius: 2px;
      cursor: pointer;
      &:hover {
        background: #1E90FF;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// IndifyDevice.vue?b5b2c92a